/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Rolled-up listing quality for the requested shop scope
 */
export type ListingQualitySummaryView = {
    /**
     * Mean quality 0–100 across reviewed listings, or null if none
     */
    quality?: number | null;
    /**
     * Band derived from mean quality
     */
    qualityBand?: ListingQualitySummaryView.qualityBand;
    /**
     * Count of current analyses with OpenAI + pending review
     */
    pendingReviewTotal?: number;
    /**
     * Acknowledged-ok swipes this cycle (per shop scope)
     */
    reviewedCount?: number;
    /**
     * Optional UX hint
     */
    message?: string | null;
};
export namespace ListingQualitySummaryView {
    /**
     * Band derived from mean quality
     */
    export enum qualityBand {
        UNKNOWN = 'unknown',
        POOR = 'poor',
        FAIR = 'fair',
        GOOD = 'good',
    }
}

